import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/game/game-client.tsx");
